import React, { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import AboutUs from "./Pages/AboutUs";
import FancyLoader from "./Components/Loader/FancyLoader";
import Toast from "./Components/Animations/Toast";

// Lazy load pages
const Home = lazy(() => import("./Pages/Home"));
const ContactForm = lazy(() => import("./Pages/ContactUs"));
const RequestProposal = lazy(() => import("./Pages/Publishers"));

const DynamicTitle = () => {
  const location = useLocation();
  useEffect(() => {
    const routeTitles = {
      "/": "AdBlastX | Premium Ad Tech Platform for Publishers & Advertisers",
      "/contact": "Contact Us - AdBlastX",
      "/publishers": "Publishers - AdBlastX",
      "/about": "About Us - AdBlastX",
    };
    document.title = routeTitles[location.pathname] || "Page Not Found - AdBlastX";
  }, [location]);
  return null;
};

const AppContent = () => {
  return (
    <>
      <DynamicTitle />
      <Suspense>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/publishers" element={<RequestProposal />} />
          <Route path="/about" element={<AboutUs />} />
        </Routes>
      </Suspense>
    </>
  );
};

const App = () => {
  const appVersion = '1.0.6'; // This app's version
  const [showLoader, setShowLoader] = useState(true);
  const [showUpdateToast, setShowUpdateToast] = useState(false);

  // Show splash screen
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  // Check for new version
  useEffect(() => {
    const storedVersion = localStorage.getItem('appVersion');
    if (storedVersion !== appVersion) {
      setShowUpdateToast(true);
      localStorage.setItem('appVersion', appVersion);
    }
  }, []);


  return (
    <>
      {/* Show loader while loading */}
      {showLoader && <FancyLoader />}

      {/* Main app content (always rendered but visually hidden when loading) */}
      <div className={showLoader ? 'opacity-0 pointer-events-none' : 'opacity-100 transition-opacity duration-300'}>
        <Router>
          <AppContent />

          {/* Update notification toast */}
          {showUpdateToast && (
            <Toast
              message="A new version App is available!"
              subMessage="Refresh to get the latest features and improvements"
              type="info"
              autoClose={false}
              position="bottom-right"
              actions={[
                {
                  label: 'Refresh Now',
                  handler: () => window.location.reload(),
                  variant: 'primary'
                },
                {
                  label: 'Later',
                  handler: () => setShowUpdateToast(false),
                  variant: 'text'
                }
              ]}
            />
          )}
        </Router>
      </div>
    </>
  );
}

export default App;